export default function AssetDiscussionCommentReplyContour() {
  return (
    <div
      aria-hidden={true}
      className="absolute rounded-xl border border-violet-200 bg-violet-50/50 shadow"
      style={{
        content: '""',
        top: -12,
        left: -12,
        width: "calc(100% + 12px)",
        height: "calc(100% + 24px)",
      }}
    />
  );
}
